import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { MessageContent, stepEnum, NumberValidationStatus, MailingMethod } from './Constant';
import { dwhMailingMethod } from './dwhReport';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';

export const getBanPsidInfo = createAsyncThunk(
  'UpdateMailingMethod/GetBanPsidInfo',
  async (blockId, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('GetBanPsidInfo', []);
      const invoiceSelectedBan = localStorage.getItem('invoiceSelectedBan');
      if (result.Body && invoiceSelectedBan) {
        localStorage.removeItem('invoiceSelectedBan');
        result.Body.invoiceSelectedBan = invoiceSelectedBan;
      }
      return result;
    } catch (error) {
      return {
        error: true,
        reason: error,
      };
    }
  }
);


export const updateMailingMethod = createAsyncThunk('UpdateMailingMethod/UpdateMailingMethod', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('updateMailingMethod', [data.newMethod, data.mailingDest, data.ban, data.isPrimaryEmail, data.CollaborationApproval]);
    thunkAPI.dispatch(hideAppLoader());
    return result;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
    };
  }
});
export const checkIsKosherOrAflaloNumber = createAsyncThunk('UpdateMailingMethod/CheckIsKosherOrAflaloNumber', async (number, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('checkIsKosherOrAflaloNumber', [number]);
    thunkAPI.dispatch(hideAppLoader());
    return result;
  } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
    };
  }
});

const initialState = {
  bansInfo: [],
  selectedBan: [],
  isLoading: false,
  showPopup: false,
  messageContent: {},
  currentStep: stepEnum.SELECT_BAN,
  currentMailingDest: '',
  primaryMail: '',
  colLabIsApproved: false,
  currentMethod: MailingMethod.Mail,//default
  dwhParams: { status: '', message: '', customerName: '', idNumber: '', param1: '', param2: '', ban: '', param3: '', actionType: '' },
};


const updateMailingMethodSlice = createSlice({
  name: 'updateMailingMethod',
  initialState: initialState,
  reducers: {
    resetState: (state) => initialState,
    setSelectedBan: (state, action) => {
      state.selectedBan = action.payload;
      return state;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
      return state;
    },
    setCurrentMethod: (state, action) => {
      state.currentMethod = action.payload;
      return state;
    },
    setShowPopUp: (state, action) => {
      state.showPopup = action.payload;
      return state;
    },

    saveToHistory: (state, action) => {
      return state;
    },
    clearHistory: (state, action) => {
      return state;
    },
    setDwhParams: (state, action) => {
      state.dwhParams = action.payload;
      return state;
    },
  },
  extraReducers: {
    [getBanPsidInfo.fulfilled]: (state, action) => {

      if (!action.payload.error) {
        var response = action.payload.Body;
        var banList =response.bansInfo.map((item) => item.ban);
        state.isLoading = false;
        var immutableBans = [];
        response.bansInfo.forEach(item => {
          //checking if  ban authorized to update mailing
          item["canUpdate"] = false;
          var type = item.accountType;
          if((type == "I" || type == "S") ||
            ((type == "C" || type == "M") &&
            (item.utcInd && (item.securityLevel == "G" || item.accountMidType == "Z")))
          ) {
            item.canUpdate = true;
          } else {
            immutableBans.push(item.ban);
          }
        });

        if(response.bansInfo.length == 1 && !immutableBans.includes(response.bansInfo[0].ban)){
          state.currentStep = stepEnum.UPDATE_MAILING_METHOD;
          state.selectedBan=[...state.selectedBan,response.bansInfo[0].ban];
        }

        if(response.bansInfo.length == 0 || response.bansInfo.every((banItem)=>immutableBans.includes(banItem.ban))){
          state.currentStep = stepEnum.UPDATE_STATUS_MESSAGE;
          state.messageContent = MessageContent.notAllowedToUpdate;
        }

        if(response.bansInfo.length > 1 && response.invoiceSelectedBan){
          state.currentStep = stepEnum.UPDATE_MAILING_METHOD;
          state.selectedBan=[...state.selectedBan,response.invoiceSelectedBan];
        }

        dwhMailingMethod({
          ...state.dwhParams,
          message: 'ban selection screen Displayed',
          ban: banList.join(';')
        })

        if (immutableBans.length > 0) {
          dwhMailingMethod({
            ...state.dwhParams,
            message: 'ban edit error',
            status: 'Error',
            ban: [...immutableBans].join(';')
          })
        }

        state.bansInfo = response.bansInfo;
        state.primaryMail = response.primaryMail;
        state.colLabIsApproved = response.collaborationApproval;
        return state;
      }
      else {
        state.currentStep = stepEnum.UPDATE_STATUS_MESSAGE;
        state.messageContent = MessageContent.generalError;
      }
    },
    [getBanPsidInfo.pending]: (state, action) => {
      state.isLoading = true;
      return state;
    },
    [getBanPsidInfo.rejected]: (state, action) => {
      state.isLoading = false;
      return state;
    },

    [updateMailingMethod.fulfilled]: (state, action) => {

      if (!action.payload.error) {
        const failedRows = action.payload.Body.body.response.updateRow.filter(rowRes => rowRes.isSuccess == "false");
        if (failedRows.length > 0) {
          state.currentStep = stepEnum.UPDATE_STATUS_MESSAGE;
          state.messageContent = MessageContent.partialUpdateSucceeded;
          state.messageContent.failedBans = failedRows.map(row => row.ban);
        }
        else {
          state.currentStep = stepEnum.UPDATE_STATUS_MESSAGE;
          state.messageContent = MessageContent.updateSucceeded;
        }
        state.dwhParams.actionType = 'Invoice updated success';
      } else {
        state.currentStep = stepEnum.UPDATE_STATUS_MESSAGE;
        state.messageContent = MessageContent.generalError;
        state.dwhParams.actionType = 'Invoice updated error';
      }
      return state;
    },
    [updateMailingMethod.pending]: (state, action) => {
      return state;
    },
    [updateMailingMethod.rejected]: (state, action) => {
      state.currentStep = stepEnum.UPDATE_STATUS_MESSAGE;
      state.messageContent = MessageContent.generalError;
      return state;
    },
    [checkIsKosherOrAflaloNumber.fulfilled]: (state, action) => {
      if (action.payload.Body.body.response.status == NumberValidationStatus.BLOCK) {
        state.messageContent = MessageContent.numberValidationFailed;
        state.showPopup = true;
      }
      return state;
    },
    [checkIsKosherOrAflaloNumber.pending]: (state, action) => {
      return state;
    },
    [checkIsKosherOrAflaloNumber.rejected]: (state, action) => {
      state.currentStep = stepEnum.UPDATE_STATUS_MESSAGE;
      state.messageContent = MessageContent.generalError;
      return state;
    },
  }
});

export const {
  setSelectedBan,
  setCurrentStep,
  setShowPopUp,
  clearHistory,
  saveToHistory,
  setCurrentMethod,
  resetState,
  setDwhParams
} = updateMailingMethodSlice.actions;

export default updateMailingMethodSlice.reducer;
